const _excluded = ["state"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { useToast } from "@react-aria/toast";
import Cross from "@bolteu/kalep-react-icons/dist/Cross";
import { GhostButton } from "../GhostButton";
import { IconButton } from "../IconButton";
import { cx } from "../../helpers/utils/cx";
function CloseButton(props) {
  return /*#__PURE__*/React.createElement(IconButton, {
    "data-testid": "snackbar-close-button",
    overrideClassName: "text-primary-inverted w-6 h-6",
    size: "sm",
    "aria-label": props["aria-label"] ?? "Close",
    onClick: props.onPress,
    icon: /*#__PURE__*/React.createElement(Cross, {
      size: "sm"
    })
  });
}
export function Snackbar(_ref) {
  let {
      state
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const snackbarRef = React.useRef(null);
  const mountedRef = React.useRef(false);
  const ariaProps = useToast(props, state, snackbarRef);
  const {
    content,
    key,
    animation
  } = props.toast;
  const {
    title,
    description,
    actions,
    dismissible
  } = content;
  React.useEffect(() => {
    mountedRef.current = true;
    return () => {
      mountedRef.current = false;
    };
  }, []);
  if (!description) {
    return null;
  }
  const actionButtons = actions?.length ? actions.map(action => {
    return /*#__PURE__*/React.createElement(GhostButton, {
      key: action.label,
      overrideClassName: "flex-shrink-0 font-semibold text-action-secondary"
      /* eslint-disable react/jsx-no-bind -- needs access to the loop variable */,
      onClick: () => {
        action.onClick();
        state.close(key);
      }
      /* eslint-enable react/jsx-no-bind */
    }, action.label);
  }) : null;
  const hasCloseButton = actionButtons ? false : dismissible ?? true;
  return /*#__PURE__*/React.createElement("div", _extends({}, ariaProps.toastProps, {
    ref: snackbarRef,
    "data-animation": animation,
    className: cx("flex items-center w-full gap-4 px-4 py-3", "bg-neutral-primary rounded-md", "bolt-font-body-s-regular text-primary-inverted", "will-change-transform", !mountedRef.current && "animate-snackbar")
  }), /*#__PURE__*/React.createElement("div", {
    className: cx("w-full flex flex-row flex-wrap gap-3")
  }, /*#__PURE__*/React.createElement("div", null, title ? /*#__PURE__*/React.createElement("div", _extends({}, ariaProps.titleProps, {
    className: cx("font-semibold mb-1")
  }), title) : null, /*#__PURE__*/React.createElement("div", ariaProps.descriptionProps, description)), actionButtons ? /*#__PURE__*/React.createElement("div", {
    className: cx("ml-auto flex items-center")
  }, /*#__PURE__*/React.createElement("div", {
    className: cx("flex gap-6 w-full justify-end")
  }, actionButtons)) : null), hasCloseButton ? /*#__PURE__*/React.createElement(CloseButton, ariaProps.closeButtonProps) : null);
}